<template>
  <b-card>
    <b-card-header class="bg-info">
      <h4 class="title">ایجاد کاربر</h4>
    </b-card-header>
    <b-card-body>
      <validation-observer #default="handleSubmit" ref="refFormObserver">
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                name="نام و نام خانوادگی"
                rules="required"
              >
                <b-form-group>
                  <label for="name">
                    <feather-icon icon="FeatherIcon" />
                    نام و نام خانوادگی
                  </label>
                  <b-form-input
                    v-model="name"
                    id="name"
                    placeholder="نام و نام خانوادگی را وارد نمایید"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                name="نام کاربری"
                rules="required"
              >
                <b-form-group>
                  <label for="username">
                    <feather-icon icon="UserIcon" />
                    نام کاربری
                  </label>
                  <b-form-input
                    v-model="username"
                    id="username"
                    placeholder="نام کاربری را وارد نمایید"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                name="موبایل"
                rules="required"
              >
                <b-form-group>
                  <label for="mobile">
                    <feather-icon icon="SmartphoneIcon" />
                    موبایل
                  </label>
                  <b-form-input
                    v-model="mobile"
                    id="mobile"
                    placeholder="موبایل را وارد نمایید"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                name="نقش کاربر"
                rules="required"
              >
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="roles">
                      <feather-icon icon="UserCheckIcon" />
                      نقش کاربر
                    </label>
                    <v-select
                      v-model="roles"
                      input-id="roles"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="slug"
                      :options="rolesList"
                      :reduce="(role) => role.id"
                      multiple
                      :close-on-select="false"
                      :class="{
                        'is-invalid': validationContext.errors.length > 0,
                      }"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                    <small class="text-muted">
                      نقش‌های اولیه‌ی کاربر. تغییرات بعدی نقش‌ها و دسترسی‌ها از
                      پنل Dash انجام می‌شود.
                    </small>
                  </b-form-group>
                </b-overlay>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <b-form-group>
                <label for="personnel_no">
                  <feather-icon icon="PhoneCallIcon" />
                  کد پرسنلی
                </label>
                <b-form-input
                  v-model="personnel_no"
                  id="personnel_no"
                  placeholder="کد پرسنلی کاربر را وارد نمایید"
                />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-overlay :show="organizationList.length === 0">
                <b-form-group>
                  <label for="organization_id">
                    <feather-icon icon="CheckSquareIcon" />
                    واحد سازمانی
                  </label>
                  <v-select
                    v-model="organization_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="organizationList"
                    :reduce="(organization) => organization.id"
                  >
                  </v-select>
                </b-form-group>
              </b-overlay>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="validationContext"
                name="نقش سازمانی"
                rules="required"
              >
                <b-form-group>
                  <label>نقش سازمانی در اتوماسیون</label>
                  <v-select
                    v-model="organization_role"
                    :options="orgRoleOptions"
                    label="label"
                    :reduce="(role) => role.value"
                    placeholder="انتخاب نقش سازمانی..."
                    dir="rtl"
                    :class="{
                      'is-invalid': validationContext.errors.length > 0,
                    }"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <b-form-group label=" تاریخ تولد" label-for="birthday">
                <date-picker
                  v-model="birthday"
                  type="date"
                  display-format="jDD jMMMM jYYYY"
                  format="YYYY-MM-DD"
                  simple
                  clearable
                />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label=" تاریخ استخدام" label-for="hired_at">
                <date-picker
                  v-model="hired_at"
                  type="date"
                  display-format="jDD jMMMM jYYYY"
                  format="YYYY-MM-DD"
                  clearable
                />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                name="رمز عبور"
                rules="required"
              >
                <b-form-group>
                  <label for="password">
                    <feather-icon icon="LockIcon" />
                    رمز عبور
                  </label>
                  <b-input-group>
                    <b-form-input
                      :type="passwordFieldType"
                      v-model="password"
                      id="password"
                      placeholder="رمز عبور را وارد نمایید"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label></label>
                <b-form-checkbox
                  checked="true"
                  name="check-button"
                  class="custom-control-success"
                  switch
                  v-model="isActive"
                >
                  فعال
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <button class="btn btn-info mt-2" @click="createUser">ذخیره کاربر</button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
  BFormInvalidFeedback,
  BFormCheckbox,
} from "bootstrap-vue";
import VSelect from "vue-select";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import farsi from "vee-validate/dist/locale/fa";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@core/utils/validations/validations";

export default {
  name: "Users_Create",
  components: {
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      name: "",
      username: "",
      mobile: "",
      roles: [],
      rolesList: [],
      organizationList: [],
      organization_id: null,
      personnel_no: "",
      birthday: null,
      hired_at: null,
      password: "",
      isActive: true,

      organization_role: null,
      orgRoleOptions: [
        { label: "مدیر (Manager)", value: "manager" },
        { label: "کاربر عادی (User)", value: "user" },
      ],
    };
  },
  mixins: [togglePasswordVisibility],
  created() {
    localize("fa", {
      messages: farsi.messages,
    });
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    createUser() {
      this.$refs.refFormObserver.validate().then((success) => {
        if (success) {
          this.$http
            .post("user/users", {
              name: this.name,
              username: this.username,
              mobile: this.mobile,
              roles: this.roles,
              personnel_no: this.personnel_no,
              birthday: this.birthday,
              hired_at: this.hired_at,
              password: this.password,
              is_active: this.isActive,
              organization_id: this.organization_id,
              organization_role: this.organization_role,
            })
            .then(({ data }) => {
              if (data.status) {
                this.$bvToast.toast("کاربر با موفقیت ایجاد شد", {
                  title: "موفقیت",
                  toaster: "b-toaster-top-right",
                  variant: "success",
                });
                this.name = "";
                this.username = "";
                this.mobile = "";
                this.roles = [];
                this.personnel_no = "";
                this.password = "";
              } else {
                this.$bvToast.toast("در ایجاد کاربر خطایی رخ داده", {
                  title: "حطا",
                  toaster: "b-toaster-top-right",
                  variant: "danger",
                });
              }
            })
            .catch((error) => {
              this.$bvToast.toast(
                error.response.data.message ?? error.message,
                {
                  title: "خطا در دریافت اطلاعات",
                  toaster: "b-toaster-top-right",
                  variant: "danger",
                },
              );
            });
        }
      });
    },
    // The roles a new user can start with: every automation role, as the
    // auth service last sent them.
    getRoles() {
      this.$http
        .get("user/roles?paginate=false")
        .then(({ data }) => {
          if (data.status) {
            this.rolesList = data.roles;
          } else {
            this.$bvToast.toast("دریافت لیست نقش ها با خطا مواجه شد", {
              title: "خطا در دریافت اطلاعات",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
    getOrganization() {
      this.$http
        .get("organizations?result=all")
        .then(({ data }) => {
          if (data.status) {
            this.organizationList = data.organizations;
          } else {
            this.$bvToast.toast("دریافت لیست نقش ها با خطا مواجه شد", {
              title: "خطا در دریافت اطلاعات",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
  },
  mounted() {
    this.getRoles();
    this.getOrganization();
  },
  setup() {
    const { getValidationState } = formValidation(name);

    return {
      getValidationState,
    };
  },
};
</script>

<style></style>
